import { useQuery } from 'react-query'
import { getBooking } from './getBooking'

export const GetBookingQueryKey = 'getBooking'

export const getBookingQueryKey = (
  reservationGuid: string,
  restaurantGuid: string
) => [GetBookingQueryKey, restaurantGuid, reservationGuid]

export const useGetBooking = (
  reservationGuid: string,
  restaurantGuid: string,
  enabled: boolean = true
) => {
  return useQuery(
    getBookingQueryKey(reservationGuid, restaurantGuid),
    () => getBooking(reservationGuid, restaurantGuid),
    {
      enabled: Boolean(reservationGuid && restaurantGuid) && enabled
    }
  )
}
